'use client';

import { useState } from 'react';
import useBus from './use-bus';
import { AppBusEventType } from '../interfaces/bus-events';

let cachedCurrentAppId: string | null = null;

// -----------------------------------------------------------------------------
export const setCurrentAppIdCache = (id: string | null): void => {
  cachedCurrentAppId = id;
};

// -----------------------------------------------------------------------------
export const useCurrentAppId = (): string | null => {
  const [id, setId] = useState<string | null>(cachedCurrentAppId);

  useBus(AppBusEventType.App.CurrentAppChanged, (event: any) => {
    setId(event?.data?.appId ?? null);
  });

  return id;
};
